import { useAnalytics } from "@codat/analytics";
import { TextInput as OrchardTextInput } from "@codat/orchard-ui";
import { TextInputProps as OrchardTextInputProps } from "@codat/orchard-ui/dist/es/components/TextInput";
import React, { forwardRef } from "react";

interface TextInputProps extends Omit<OrchardTextInputProps, "ref"> {
  inputName: string;
  eventProperties?: Record<string, unknown>;
}

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  function TextInput(props, ref) {
    const { inputName, eventProperties, onChange, ...textInputProps } = props;
    const { sendEvent } = useAnalytics();

    const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (onChange) {
        onChange(e);
      }
    };

    const handleOnFocusWithTracking = () => {
      sendEvent(`${inputName} Input - Focus`, eventProperties);
    };

    return (
      <OrchardTextInput
        ref={ref}
        onChange={handleOnChange}
        onFocus={handleOnFocusWithTracking}
        {...textInputProps}
      />
    );
  }
);
